import React, { useState } from 'react';
import axios from 'axios';
import { Loader2, ShieldCheck, Send } from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const inp = 'w-full px-3 py-2.5 border border-slate-300 rounded-md text-sm focus:outline-none focus:border-[#002FA7] focus:ring-2 focus:ring-[#002FA7]/20';

export const CompanyAccessRequestForm = ({ initial = {}, onDone }) => {
  const [f, setF] = useState({ requester_name: initial.requester_name || '', requester_email: initial.requester_email || '', phone: initial.phone || '', dot_number: initial.dot_number || '', mc_number: initial.mc_number || '', message: '' });
  const [busy, setBusy] = useState(false); const [sent, setSent] = useState(false); const [error, setError] = useState('');
  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });

  const submit = async (e) => {
    e?.preventDefault?.(); setError('');
    if (!f.requester_name.trim() || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(f.requester_email)) { setError('Please enter your name and a valid e-mail.'); return; }
    setBusy(true);
    try {
      await axios.post(`${API}/company-access-requests`, { ...f, phone: f.phone || undefined, dot_number: f.dot_number || undefined, mc_number: f.mc_number || undefined, message: f.message || undefined });
      setSent(true); onDone?.();
    } catch (err) {
      setError(err.response?.status === 429 ? 'Too many requests — please try again later.' : 'Could not submit your request. Please try again.');
    } finally { setBusy(false); }
  };

  if (sent) {
    return (
      <div className="p-4 rounded-md bg-emerald-50 border border-emerald-200 text-sm text-emerald-800" data-testid="access-request-sent">
        <p className="font-semibold flex items-center gap-2"><ShieldCheck className="w-4 h-4" /> Request received</p>
        <p className="mt-1">Our team will verify your request with the registered company and e-mail you an invite if approved. Nothing is granted automatically.</p>
      </div>
    );
  }
  return (
    <div className="space-y-3" data-testid="access-request-form">
      {error && <div className="p-2 rounded bg-red-50 border border-red-200 text-xs text-red-700" data-testid="access-request-error">{error}</div>}
      <div className="grid sm:grid-cols-2 gap-3">
        <input placeholder="Your name" value={f.requester_name} onChange={set('requester_name')} className={inp} data-testid="access-request-name" />
        <input type="email" placeholder="Work e-mail" value={f.requester_email} onChange={set('requester_email')} className={inp} data-testid="access-request-email" />
      </div>
      <div className="grid sm:grid-cols-3 gap-3">
        <input placeholder="Phone (optional)" value={f.phone} onChange={set('phone')} className={inp} data-testid="access-request-phone" />
        <input placeholder="USDOT #" value={f.dot_number} onChange={set('dot_number')} className={inp} data-testid="access-request-dot" />
        <input placeholder="MC #" value={f.mc_number} onChange={set('mc_number')} className={inp} data-testid="access-request-mc" />
      </div>
      <textarea rows={2} placeholder="Your role at the company and why you need access (optional)" value={f.message} onChange={set('message')} className={inp} data-testid="access-request-message" />
      <button type="button" onClick={submit} disabled={busy} className="inline-flex items-center gap-2 px-4 py-2 rounded-md bg-slate-900 text-white text-sm font-semibold disabled:opacity-60" data-testid="access-request-submit">
        {busy ? <Loader2 className="w-4 h-4 animate-spin" /> : <Send className="w-4 h-4" />} Request access
      </button>
    </div>
  );
};
